<div class="people-page">
    <!-- <section class="groups-section">
        <div class="section-header">
            <h1>Groups</h1>
            <button class="invite-btn" (click)="openCreateGroupDialog()">+ Create Group</button>
        </div>

        <div class="table-container">
            <app-table #groupsTable [construct]="groupConstruct">
            </app-table>
        </div>
    </section> -->

    <section class="users-section">
        <div class="section-header">
            <h1>Users</h1>
            <button class="invite-btn" (click)="openInviteDialog()">+ Invite Users</button>
        </div>

        <div class="table-container">
            <app-table #usersTable [construct]="usersConstruct">
            </app-table>
        </div>
    </section>
</div>

<!-- Custom cell template for the name field -->
<ng-template #nameFieldTemplate let-person>
    <div class="name-cell-container">
        <div class="name-info">
            <div class="name-field">
                {{ person.fullName | isYou : person.email }}
            </div>
            <div class="name-status" [class]="'status-' + person.status?.toLowerCase()">
                {{ person.status | titlecase }}
            </div>
        </div>
        <div class="name-email">
            {{ person.email }}
        </div>
    </div>
</ng-template>